(function() { window.GUID_685635fe_4e41_4ad6_bc3a_9bf62c07cc04 = { getGuid: function() { return "685635fe-4e41-4ad6-bc3a-9bf62c07cc04"; } }; })();
//TODO:POP
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var ImageCropperAddons;
        (function (ImageCropperAddons) {
            class ImageCropperWebcam extends ImageCropperAddons.Base {
                constructor(mainHelper) {
                    super(mainHelper);
                    this.OnError = (errorName) => { };
                    this.captureImage = () => {
                        let me = this;
                        let video = this.$video[0];
                        let canvas = document.createElement("canvas");
                        let captureInfo = me.getCaptureInfo();
                        //let boost = 4;
                        canvas.width = captureInfo.Size.Width;
                        canvas.height = captureInfo.Size.Height;
                        //let offsetX = 0;
                        //let offsetY = 0;
                        //if (me.$video.hasClass('portrait')) {
                        //    offsetX = (canvas.width - (me.$video.width() * boost)) / 2; // centre la capture
                        //}
                        //else {
                        //    offsetY = (canvas.height - (me.$video.height() * boost)) / 2; // centre la capture
                        //}
                        canvas.getContext('2d').drawImage(video, captureInfo.offset.X, captureInfo.offset.Y, me.$video.width() * captureInfo.boost, me.$video.height() * captureInfo.boost);
                        canvas.toBlob(function (blob) {
                            let url = (window.URL ? URL : webkitURL).createObjectURL(blob); //Use webkit Url if URL is not available
                            me.imageCapturedCallback.call(this, url);
                            me.Close();
                        });
                    };
                    let me = this;
                    //this.stateHelper = new Controls.NavigationPushState<IShowParam>({
                    //    onShow: (param) => {
                    //        if (param && param.overlayUrl != null && param.overlayUrl != "") {
                    //            let img = new Image();
                    //            img.onload = function () {
                    //                me.setupCam(param.imageCapturedCallback, img);
                    //            };
                    //            img.className = "overlay";
                    //            img.src = param.overlayUrl;
                    //        }
                    //        else {
                    //            me.setupCam(param.imageCapturedCallback, null, param.size);
                    //        }
                    //    },
                    //    onHide: (param) => {
                    //        this.Dispose();
                    //    },
                    //});
                }
                static IsSupported() {
                    if (navigator.getUserMedia || (navigator.webkitGetUserMedia) || (navigator.mozGetUserMedia))
                        return true;
                    return false;
                }
                handleVideo(stream) {
                    let video = this.$video[0];
                    let me = this;
                    if (navigator.getUserMedia) { // Standard
                        //(<any>this.videoElement).src = stream;
                        video.srcObject = stream;
                        video.play();
                        video.onloadedmetadata = (e) => {
                            video.play();
                        };
                    }
                    else if (navigator.webkitGetUserMedia) { // WebKit  
                        video.src = window.webkitURL.createObjectURL(stream);
                        video.play();
                    }
                    else if (navigator.mozGetUserMedia) { // Firefox
                        video.src = window.URL.createObjectURL(stream);
                        video.play();
                    }
                    video.onloadeddata = function () {
                        var captureInfo = me.getCaptureInfo();
                        //me.$video.css({
                        //    marginLeft: -(captureInfo.offset.X) + 'px',
                        //    marginTop: -(captureInfo.offset.Y) + 'px'
                        //});
                        //+ me.$inner.css('left').replace("px", "")
                        //+ me.$inner.css('top').replace("px", "")
                        if (me.$video.hasClass('portrait')) {
                            me.$video.css({
                                marginLeft: -((me.$video.width() / 4) - me.$inner.position().left - 7) + 'px'
                            });
                        }
                        else {
                            me.$video.css({
                                marginTop: -((me.$video.height() / 4) - me.$inner.position().top - 7) + 'px'
                            });
                        }
                    };
                    //video.src = window.URL.createObjectURL(stream);
                    this.streamTrack = stream.getTracks()[0];
                    this.stream = stream;
                }
                errorVideo(error) {
                    this.OnError(error["name"]);
                    this.$video.remove();
                }
                Show(overlayUrl, imageCapturedCallback) {
                    let me = this;
                    //this.stateHelper.Show({ imageCapturedCallback, overlayUrl });
                    if (overlayUrl != null && overlayUrl != "") {
                        let img = new Image();
                        img.onload = function () {
                            me.setupCam(imageCapturedCallback, img);
                        };
                        img.className = "overlay";
                        img.src = overlayUrl;
                    }
                    else {
                        me.setupCam(imageCapturedCallback);
                    }
                }
                ShowWithoutOverlay(size, imageCapturedCallback) {
                    let me = this;
                    //this.stateHelper.Show({ imageCapturedCallback, size });
                    me.setupCam(imageCapturedCallback, null, size);
                }
                setupCam(imageCapturedCallback, overlay, size) {
                    const me = this;
                    this.imageCapturedCallback = imageCapturedCallback;
                    this.$imageCropperWebcam = $('<div class="image-cropper-webcam"></div>');
                    this.$inner = $('<div class="inner"></div>');
                    this.$imageCropperWebcam.append(this.$inner);
                    this.$video = $('<video autoplay="true"></video>');
                    this.$videoContainer = $('<div class="video-container"></div>');
                    this.$videoContainer.append(this.$video);
                    this.$inner.append(this.$videoContainer);
                    let $overlay = $(overlay);
                    if ($overlay.length > 0) {
                        ImageCropperAddons.ImageCropperPopup.SetSizeBasedOnContainedImage($overlay);
                    }
                    else {
                        $overlay = $('<div/>').addClass("overlay");
                        ImageCropperAddons.ImageCropperPopup.SetSizeBasedOnContainedImage($overlay, size);
                    }
                    this.$inner.append($overlay);
                    // Nouveau UI
                    let $imageCropperCropSpace = $(`
                <div class="image-cropper-cropspace-container pointer-events--none">
                    <div class="image-cropper-cropspace">
                        <div class="image-cropper-overlay-corner-borders"></div>
                    </div>
                </div>
            `);
                    let $topBar = $(`
                <div class="image-cropper__top-bar"></div>
            `);
                    let $topBarColLeft = $(`
                <div class="col"></div>
            `);
                    let $topBarColRight = $(`
                <div class="col"></div>
            `);
                    this.$closeButton = $(`
                <button class="button button--big csico btn-cropper btn-close">
                    <div class="icon ic-cs-arrow-left"></div>
                </button>
            `);
                    let $bottomBar = $(`
                <div class="image-cropper__bottom-bar"></div>
            `);
                    let $bottomBarColLeft = $(`
                <div class="col"></div>
            `);
                    let $bottomBarColRight = $(`
                <div class="col"></div>
            `);
                    let $captureButton = $(`
                <button class="button button--big button--secondary btn-capture">
                    ${Controls.ImageCropper.Ress.TakePicture()}
                </button>
            `);
                    $topBarColLeft.append(this.$closeButton);
                    $topBar.append([$topBarColLeft, $topBarColRight]);
                    $bottomBarColRight.append($captureButton);
                    $bottomBar.append([$bottomBarColLeft, $bottomBarColRight]);
                    this.$inner.append($imageCropperCropSpace);
                    this.$inner.append($topBar);
                    this.$inner.append($bottomBar);
                    // ./Nouveau UI
                    //this.$closeButton = $('<button class="btn-close">X</button>');
                    //this.$inner.append(this.$closeButton);
                    CS.DOM.$body.append(this.$imageCropperWebcam);
                    this.$imageCropperWebcam.show();
                    let innerPadding = parseInt(this.$inner.css('left').replace("px", "")); //Le 7 correspond au padding du Body + un border de 2px;
                    ImageCropperAddons.ImageCropperPopup.FitElement($overlay, innerPadding, this.$imageCropperWebcam);
                    let ratio = $overlay.width() / $overlay.height();
                    if (ratio > 1) {
                        this.$video.removeClass('portrait');
                        this.$video.addClass('paysage');
                    }
                    else {
                        this.$video.addClass('portrait');
                        this.$video.removeClass('paysage');
                    }
                    const videContainerCss = {
                        width: $overlay.width() + 'px',
                        height: $overlay.height() + 'px',
                        left: $overlay.css('left'),
                        top: $overlay.css('top'),
                        marginLeft: $overlay.css('margin-left'),
                        marginTop: $overlay.css('margin-top')
                    };
                    $imageCropperCropSpace.css(videContainerCss);
                    this.$videoContainer.css(videContainerCss);
                    this.$closeButton.offon('click.close-button', function () {
                        me.Close();
                    });
                    let setting = {
                        video: true,
                        audio: false
                    };
                    // Ask the browser for permission to use the Webcam
                    if (navigator.getUserMedia) { // Standard
                        navigator.getUserMedia(setting, (stream) => me.handleVideo(stream), (error) => me.errorVideo(error));
                    }
                    else if (navigator.webkitGetUserMedia) { // WebKit
                        navigator.webkitGetUserMedia(setting, (stream) => me.handleVideo(stream), (error) => me.errorVideo(error));
                    }
                    else if (navigator.mozGetUserMedia) { // Firefox
                        navigator.mozGetUserMedia(setting, (stream) => me.handleVideo(stream), (error) => me.errorVideo(error));
                    }
                    setTimeout(() => {
                        $captureButton.offon('click.image-cropper-webcam', () => {
                            me.captureImage();
                        });
                        $overlay.offon('click.image-cropper-webcam', () => {
                            me.captureImage();
                        });
                    }, 500);
                }
                getCaptureInfo() {
                    let me = this;
                    let boost = 4;
                    var size = new CS.Size(me.$videoContainer.width() * boost, me.$videoContainer.height() * boost);
                    let offsetX = 0;
                    let offsetY = 0;
                    if (me.$video.hasClass('portrait')) {
                        offsetX = (size.Width - (me.$video.width() * boost)) / 2; // centre la capture
                    }
                    else {
                        offsetY = (size.Height - (me.$video.height() * boost)) / 2; // centre la capture
                    }
                    return {
                        Size: size,
                        offset: { X: offsetX, Y: offsetY },
                        boost
                    };
                }
                Close() {
                    this.Dispose();
                }
                OnDispose() {
                    if (this.stream != null) {
                        this.streamTrack.stop();
                    }
                    if (this.$video)
                        this.$video.remove();
                    if (this.$imageCropperWebcam != null) {
                        this.$imageCropperWebcam.remove();
                    }
                    this.$imageCropperWebcam = null;
                }
            }
            ImageCropperAddons.ImageCropperWebcam = ImageCropperWebcam;
        })(ImageCropperAddons = Controls.ImageCropperAddons || (Controls.ImageCropperAddons = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=image-cropper-webcam.js.map
